import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from 'react-router/lib/withRouter';
import * as actions from '../actions';
import { get } from 'Language';

class SignUp extends Component {

	state = {
		sport: '',
		email: '',
		password: '',
		confirm_password: ''
	}

	componentWillMount() {
		const { getSports } = this.props;
		getSports();
	}

	onChange = (e) => {
		const nextState = {};
		const { name, value } = e.target;
		nextState[name] = value;
		this.setState(nextState);
	}

	submit = (e) => {
		e.preventDefault();
		const { signUp } = this.props;
		signUp(this.state);
	}

	componentDidUpdate(prevProps, prevState) {
		const { onSignUp } = this.props;
		if(this.props.success) {
			this._form.reset();
			this.resetState();
			onSignUp(false);
		}
	}

	resetState = () => {
		this.setState({
			sport: '',
			email: '',
			password: '',
			confirm_password: ''
		})
	}

    render(){
    	
    	const { isWaiting } = this.props;

		return (
			<div className="main-content">
			    <div className="row">
			        <div className="col-md-12 home">
			            <h1>{ get('REGISTER_TITLE') }</h1>
			        </div>
			    </div>
			    <div className="row">
			        <div className="col-md-12">
			            <div className="panel panel-custom">
			            	<form onSubmit={ this.submit }>
				                <div className="panel-body">
				                        <div className="form-group">
				                            <label>{ get('EMAIL') }</label>
				                            <input 
				                            	type="text" 
				                            	name="email" 
				                            	className="form-control form-custom"
				                            	onChange={this.onChange}/>
				                        </div>

				                        <div className="form-group">
				                            <label>{ get('REGISTER_FORM_PASSWORD') }</label>
				                            <input 
				                            	type="password" 
				                            	name="password" 
				                            	className="form-control form-custom"
				                            	onChange={this.onChange}/>
				                        </div>

				                        <div className="form-group">
				                            <label>{ get('REGISTER_FORM_CONFIRM_PASSWORD') }</label>
				                            <input 
					                            type="password" 
					                            name="confirm_password" 
					                            className="form-control form-custom"
					                            onChange={this.onChange}/>
				                        </div>

				                        <div className="form-group">
				                            <label>{ get('PROFILE_SPORT') }</label>
				                            <select 
				                            	name="sport" 
				                            	className="form-control form-custom" 
				                            	onChange={ this.onChange } 
				                            	value={ this.state.sport }>
				                            	<option value="">--Select Sports--</option>
				                            	{ this.props.sports.map(item => {
				                            		return (
				                            			<option value={item.id} key={item.id}>{ item.name }</option>
				                            		)
				                            	})}
				                            </select>
				                        </div>

				                        <div className="btn-custom text-right">
				                            <button disabled={ isWaiting } type="submit" className="btn btn-primary">
				                            	<i className={`fa ${isWaiting ? 'fa-spin fa-spinner' : 'fa-arrow-circle-right'}`}></i>&nbsp;
				                            	{ isWaiting
				                            		? 'Loading...'
				                            		: get('REGISTER_TITLE')
				                            	}
				                            </button>
				                        </div>
				                </div>
			                </form>
			            </div>
			        </div>
			    </div>
			</div>
		)
	}
}

export default withRouter(connect(
	(state, routeParams) => {
		const { sports, success } = state.signUp;
		const { isWaiting } = state.onWaiting;
		        
		return {
            sports,
            isWaiting,
            success
		}
	},
	actions
)(SignUp))


// WEBPACK FOOTER //
// ./src/sign-up/containers/SignUp.js